module.exports = __webpack_public_path__ + "static/media/4_elephant_naga.ea1f48c9.png";